import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';

export interface Props {
  productLicenseTitle: string;
}

function LicenseExpired({ productLicenseTitle }: Props) {
  return (
    <div className="bg-red-50 border-1 border-red-400 rounded mb-2.5">
      <p className="text-sm p-3">
        <T
          kind="The {{name}} license associated with this collection is no longer active..."
          name={productLicenseTitle}
        />
      </p>
    </div>
  );
}

export default observer(LicenseExpired);
